import {
  apiRoutes,
  getOptimizeRoutesFn,
  type DefaultQueryError,
  type OptimizedRoutesResponse,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetOptimizeRoutes = (
  optimizeStringParam: string,
  opts?: UseQueryOptions<OptimizedRoutesResponse, DefaultQueryError, string>
) =>
  useQuery<OptimizedRoutesResponse, DefaultQueryError, string>({
    queryKey: [apiRoutes.osrm.driving, optimizeStringParam],
    queryFn: () => getOptimizeRoutesFn(optimizeStringParam),
    ...opts,
  });
